import routes from 'routes/routes';
import { ROLE_COMPRAS, ROLE_DROPSHIPPER, ROLE_ADMINISTRATOR } from 'constants/roleType';
const withRoles: any = {};
const ROLES = [ROLE_COMPRAS, ROLE_DROPSHIPPER, ROLE_ADMINISTRATOR];
for (const iterator of ROLES) {
  const role: any = iterator.toLowerCase();
  withRoles[role] = [];
  routes.forEach((item) => {
    if (item?.permission.includes(role)) {
      withRoles[role].push(item);
    }
  });
}
export default {
  ...withRoles
};
